import 'css-chunksrc/client/scenes/list/details/nameForm/styles.scss';export default {
  "input": "_input_10628_1",
  "invalid": "_invalid_10628_16"
};